import request from '@/utils/request'

let ExpensesApi = {

  setting(data) {

    return request._post('/shop/plus.expenses.Setting/setting', data);
  },
  getSetting(data) {

    return request._post('/shop/plus.expenses.Setting/getSetting', data);
  },
  getExpensesList(data){//获取报销数据

    return request._post('/shop/plus.expenses.Index/getExpensesList', data);
  },
//   通过报销审批
auditExpenses(data){

    return request._post('/shop/plus.expenses.Index/auditExpenses', data);
  },
  //驳回报销审批
  rejectExpenses(data){

    return request._post('/shop/plus.expenses.Index/rejectExpenses', data);
  },
//获取报销记录
getExpensesRecord(data){
  return request._post('/shop/plus.expenses.Index/getExpensesRecord', data);
},
  



}
export default ExpensesApi;



// WEBPACK FOOTER //
// ./src/api/expenses.js